import { useState } from 'react';
import Booking from './Booking';
import { Helmet } from 'react-helmet';
import "../styles/Navbar.css"

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleNavClick = (e, id) => {
    e.preventDefault();
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Lu - Fit Personal Training",
            "url": "https://basic-tier-personal-trainer.vercel.app/",
            "logo": "https://basic-tier-personal-trainer.vercel.app/media/logo/logo-1.png",
            "sameAs": [
              "https://instagram.com/lufit_collective/",
              "https://facebook.com/luyanda.mangcotywa/"
            ]
          })}
        </script>
      </Helmet>

      <nav className="navbar" role="navigation" aria-label="Main navigation">
        <div className="navbar-logo">
          <a
            href="/"
            aria-label="Go to homepage"
          >
            <img
              src="/media/logo/logo-1.webp"
              alt="Lu - Fit logo"
              width="100"
              height="auto"
              loading="lazy"
            />
          </a>
        </div>

        <ul className={`navbar-links ${isOpen ? 'open' : ''}`}>
          <li>
            <a 
              href="/#about-us" 
              onClick={(e) => handleNavClick(e, 'about-us')}
              aria-label="Learn more about me "
            >
              About Me
            </a>
          </li>
          <li>
            <a
              href="/#services"
              onClick={(e) => handleNavClick(e, 'services')}
              aria-label="View personal training services"
            >
              Training
            </a>
          </li>
          <li>
            <a
              href="/#rates"
              onClick={(e) => handleNavClick(e, 'rates')}
              aria-label="Read client testimonials"
            >
              Pricing
            </a>
          </li>
          <li>
            <a
              href="/#testimonials"
              onClick={(e) => handleNavClick(e, 'testimonials')}
              aria-label="Read client testimonials"
            >
              Testimonials
            </a>
          </li>
          <li>
            <a
              href="/#contact"
              onClick={(e) => handleNavClick(e, 'contact')}
              aria-label="Contact Lu - Fit"
            >
              Contact Me
            </a>
          </li>
        </ul>

        <button
          type="button"
          className="btn"
          onClick={() => setIsModalOpen(true)}
          aria-label="Book a training session"
        >
          Book Now
        </button>

        <div
          className={`burger ${isOpen ? 'toggle' : ''}`}
          onClick={toggleMenu}
          role="button"
          tabIndex={0}
          aria-label="Toggle menu"
          aria-expanded={isOpen}
        >
          <div className="line1"></div>
          <div className="line2"></div>
          <div className="line3"></div>
        </div>
      </nav>

      <Booking isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
    </>
  );
}

export default Navbar;
